import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import Results from '../components/Results'
import { textCleanup } from '../utils/textCleanup'

const Main = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  min-height: 100vh;
`

const Subject = props => {
  const [id, setId] = useState('')
  const [name, setName] = useState('Retrieving Records...')
  const [description, setDescription] = useState('')
  const [image, setImage] = useState('')
  const [cv, setCv] = useState([])

  useEffect(() => {
    //Marvel API: https://developer.marvel.com/
    const url = `https://gateway.marvel.com:443/v1/public/characters/${props.match.params.number}?apikey=541f922513aa3b4e06a535f280c5194b`
    fetch(url)
      .then(response => response.json())
      .then (data => {
          const desc = textCleanup(data.data.results[0].description)
          const cvList = data.data.results[0].events.items
          if (desc.length > 0) {
            setDescription(desc)
          } else {
            setDescription('Status Unknown')
          }
          setId(data.data.results[0].id)
          setName(data.data.results[0].name)
          setImage(data.data.results[0].thumbnail.path + '/standard_xlarge.' + data.data.results[0].thumbnail.extension)
          if (cvList.length > 0) {
            setCv(cvList.map(event => (
              event.name
            )))
          } else {
            setCv(['Unknown'])
          }
      })
      .catch(error => {
          console.log('it broke')
        })
  }, [])

    return (
      <Main>
        <Results
          id={ id }
          name={ name }
          description={ description }
          image={ image }
          cv={ cv }
        />
      </Main>
    )
  }

export default Subject
